import Color from 'color';

import type {ThemeAndAnyColor, WithThemeProp} from '../theme';

import {getColor} from './getColor';

export const getAlphaColor =
  (color: ThemeAndAnyColor, alpha: number) =>
  <ComponentProps extends WithThemeProp>(p: ComponentProps) => {
    const themeColor = getColor(color)(p);
    const normalizedAlpha = Math.min(1, Math.max(0, alpha));

    return Color(themeColor).alpha(normalizedAlpha).toString();
  };
